import React from "react";
import mapServiceItem from "./mapServiceItem";

function getChannelSlug(title) {
    return String(title || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

function ChannelIcon({ title }) {
    const commonProps = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
    };

    switch (getChannelSlug(title)) {
        case "youtube":
            return (
                <svg {...commonProps}>
                    <rect x="3.5" y="6.5" width="17" height="11" rx="3.2" />
                    <path d="m10.1 9.5 5.2 2.5-5.2 2.5Z" fill="currentColor" stroke="none" />
                </svg>
            );
        case "instagram":
            return (
                <svg {...commonProps}>
                    <rect x="4.5" y="4.5" width="15" height="15" rx="4.2" />
                    <circle cx="12" cy="12" r="3.4" />
                    <circle cx="17" cy="7.1" r="0.7" fill="currentColor" stroke="none" />
                </svg>
            );
        case "linkedin":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M6.7 8.3A1.7 1.7 0 1 0 6.7 5a1.7 1.7 0 0 0 0 3.3ZM5.3 9.7h2.8V19H5.3V9.7Zm4.6 0h2.7V11h.1c.4-.7 1.4-1.6 2.9-1.6 3.1 0 3.7 2 3.7 4.7V19h-2.8v-4.3c0-1 0-2.4-1.5-2.4s-1.7 1.1-1.7 2.3V19H9.9V9.7Z" />
                </svg>
            );
        case "tiktok":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M14.6 4c.5 1.5 1.4 2.6 2.8 3.3.8.4 1.7.6 2.6.7v2.8c-1.6-.1-3.2-.7-4.5-1.6v5.2c0 2.9-2.1 5.1-5.1 5.1A5 5 0 0 1 5.3 15c0-2.8 2.2-5.1 5.1-5.1.3 0 .6 0 .9.1v2.9a2.3 2.3 0 0 0-3.2 2.1c0 1.2 1 2.2 2.2 2.2s2.1-.9 2.1-2.2V4h2.2Z" />
                </svg>
            );
        case "facebook":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M13.4 20v-7h2.4l.4-2.8h-2.8V8.4c0-.8.2-1.4 1.4-1.4h1.5V4.5c-.3 0-1.1-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2H8v2.8h2.4v7h3Z" />
                </svg>
            );
        case "spotify":
            return (
                <svg {...commonProps}>
                    <path d="M7.2 10.2c3.2-1 6.7-.6 9.3.9" />
                    <path d="M8 13c2.5-.7 5.1-.4 7.2.8" />
                    <path d="M8.8 15.7c1.8-.4 3.6-.2 5.1.6" />
                </svg>
            );
        default:
            return <span aria-hidden="true">{title?.charAt(0)}</span>;
    }
}

export default function ProductionChannels({ items }) {
    return (
        <div className="production-channels">
            {items.map((item) => {
                const card = mapServiceItem(item);
                const slug = getChannelSlug(card.title);

                return (
                    <article className="production-channel" key={card.title}>
                        <span className={`production-channel-icon production-channel-icon-${slug}`}>
                            <ChannelIcon title={card.title} />
                        </span>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                    </article>
                );
            })}
        </div>
    );
}
